// Falls REACT_APP_API_URL nicht gesetzt ist, wird die API same-origin
// angesprochen (der Go-Server liefert sowohl das Webapp-Bundle als auch
// die API unter derselben Domain aus).
export const API_URL = process.env.REACT_APP_API_URL || window.location.origin
